import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import ServicesPage from './ServicesPage';
import TrainingPage from './trainingPage';
import AIEngineerAugmentationPage from './ai_eng_aug';
import AIProjectExecutionPage from './ai_project_exe';
import AIConsultingServicesPage from './ai_consulting_service';
import AISecurityGovernancePage from './ai_sec_gov';
import CustomAIMLSolutionsPage from './custom_aiml_sol';
import FullStackAISolutionsPage from './fullstack_ai_sol';
import DataLabellingServicesPage from './data_labelling_service';
import AIServicesContentBrochurePage from './ai_service_content_brochure';
import AIFundamentals from './ai_fundamentals'
import CorporateAITrainingPage from './corporate_training';
import AIFellowshipPage from './ai_fellowship';
import PromptEngineeringPage from './prompt_eng'; 
import StudentProgramPage from './student_patch';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/ai-engineer-augmentation" element={<AIEngineerAugmentationPage />} />
        <Route path="/ai-project-execution" element={<AIProjectExecutionPage />} />
        <Route path="/ai-consulting-services" element={<AIConsultingServicesPage />} />
        <Route path="/ai-security-governance" element={<AISecurityGovernancePage />} />
        <Route path="/custom-ai-ml-solutions" element={<CustomAIMLSolutionsPage />} />
        <Route path="/fullstack-ai-solutions" element={<FullStackAISolutionsPage />} />
        <Route path="/data-labelling-services" element={<DataLabellingServicesPage />} />
        <Route path="/ai-services-content-brochure" element={<AIServicesContentBrochurePage />} />
        <Route path="/ai-fundamentals" element={<AIFundamentals />} />
        <Route path="/corporate-ai-training" element={<CorporateAITrainingPage />} />
        <Route path="/ai-fellowship" element={<AIFellowshipPage />} />
        <Route path="/prompt-engineering" element={<PromptEngineeringPage />} />
        <Route path="/student-program" element={<StudentProgramPage />} />
      </Routes>
    </Router>
  );
}

export default App;